import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RollerLoaderComponent } from './rollerloader.component'

@NgModule({
    imports: [CommonModule],
    declarations: [RollerLoaderComponent],
    exports: [RollerLoaderComponent],
})
export class RollerLoaderModule {}
